export const API_LOBBY = '/apiLobby.php';
